import styled from 'styled-components';

import { basicBodyTextStyle, colorsMatrix, fonts } from '@dreryk/react-components';

export const StyledCalendarPatientSection = styled.div`
   ${basicBodyTextStyle};
   background: ${colorsMatrix.blue.lighter};
   padding: 18px;
   border-radius: 20px;
   z-index: 1;
`;
StyledCalendarPatientSection.displayName = 'StyledCalendarPatientSection';

export const StyledName = styled.div`
   font-weight: ${fonts.fontWeightBold};
   overflow-wrap: break-word;
`;
